import React from "react";
import { createRoot, Root } from "react-dom/client";
import { Video } from "../components/Video";
import { useI18n } from "../domain/i18n";

/**
 * This hook locates all elements that have a `data-video` attribute
 * and initializes the <Video> component in those places.
 */
export function useVideo() {
  const I18n = useI18n();

  React.useEffect(() => {
    const roots: Root[] = [];

    const videoElements = document.querySelectorAll("[data-video]");

    videoElements.forEach((el) => {
      const { id, title } = (el as HTMLElement).dataset;

      if (id && title) {
        const root = createRoot(el);
        root.render(React.createElement(Video, { I18n, id, title, aspectRatio: 16 / 9 }));

        roots.push(root);
      }
    });

    return () => {
      roots.forEach((root) => root.unmount());
    };
  }, [I18n]);
}
